<script>
  import { links } from './stores.js';
  import VerticalSpacing from './comp/vertical-spacing.svelte';
  import LinkButton from './comp/link-button.svelte';
  import Cautions from './comp/cautions.svelte';

  const buttons = {
    kakao: { src: '/imgs/kakaotalk.png', desc: '황금메쥬', href: links.kakao },
    insta: {
      src: '/imgs/instagram.png',
      desc: 'golden_meju',
      href: links.insta,
    },
    survey: {
      src: '/imgs/reserve.png',
      desc: '예약하기',
      href: links.survey,
    },
  };
</script>

<section class="container">
  <div class="title">상담 및 예약</div>
  <VerticalSpacing marginTop="30" />
  <div class="desc">문의주시면 언제나 친절하게 답변드리겠습니다.</div>
  <VerticalSpacing marginTop="50" />
  <div class="tel-title">대표 전화번호</div>
  <VerticalSpacing marginTop="20" />
  <div class="tel-desc">010.9512.7502</div>
  <VerticalSpacing marginTop="60" />
  <LinkButton {...buttons.survey} />
  <VerticalSpacing marginTop="20" />
  <LinkButton {...buttons.kakao} />
  <VerticalSpacing marginTop="20" />
  <LinkButton {...buttons.insta} />
  <VerticalSpacing marginTop="80" />
  <Cautions />
  <VerticalSpacing marginTop="120" />
</section>

<style>
  .container {
    width: 64%;
    margin: 0 auto;
  }

  .title {
    width: 100%;
    text-align: center;
    font-weight: 400;
    font-size: 48px;
  }

  .desc {
    width: 100%;
    text-align: center;
    font-weight: 200;
    font-size: 24px;
    word-break: keep-all;
  }

  .tel-title {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 32px;
  }

  .tel-desc {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 64px;
  }

  @media screen and (max-width: 1300px) {
    .container {
      width: 90%;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 96%;
      margin: 0 auto;
    }
    .tel-desc {
      font-weight: 500;
      font-size: 40px;
    }
  }
</style>
